import axios from 'axios';
import properties from '../../config/environmentProperties';
import LocalStorageService from './localstorageservice';
import { toast } from 'react-toastify';
const localStorageService = new LocalStorageService();
const headers = {
    'Accept': 'application/json'
};

const reqHandler = (config, e) => {
    document.body.classList.add('loading-indicator');
    // console.log("reqHandler", config, e);
    const token = localStorageService.getAccessToken();
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.headers['Accept'] = 'application/json';
    // config.headers['Content-Type'] = 'application/json';
    // console.info("reqHandler", "API Request", config);
    return config
}

const reqErrorHandler = (error) => {
    console.log("reqErrorHandler", "API Error", error);
    document.body.classList.remove('loading-indicator');
    Promise.reject(error)
}

const resHandler = (response) => {
    document.body.classList.remove('loading-indicator');
    // console.info("resHandler", "API Response", response);
    return response
}

const resErrorHandler = (error) => {
    console.error("resErrorHandler", "API Error", error);
    document.body.classList.remove('loading-indicator');
    return Promise.reject(error)
}


export {
    headers, reqErrorHandler, reqHandler, resErrorHandler, resHandler
}